import { watch, toValue, type MaybeRefOrGetter } from "vue";

interface AuthErrorStore {
    errors: Array<{ field?: string }>;
    clearErrors: () => void;
}

export function useAuthErrorsResetOnInput(
    inputs: MaybeRefOrGetter<unknown>[],
    authStore: AuthErrorStore,
): void {
    watch(
        () => inputs.map((input) => toValue(input)),
        () => {
            if (authStore.errors.length > 0) {
                authStore.clearErrors();
            }
        },
    );
}
